(function () {
  "use strict";
  if (window.__bbPrebuiltNote) return;
  window.__bbPrebuiltNote = true;

  var SECTIONS = "section-ajax-cart,main-cart";
  var state = { mode: "edit", payload: null, selectedVariantId: null };

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function modal() { return qs("[data-bb-prebuilt-modal]"); }

  function cartRoot() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return r.slice(-1) === "/" ? r : r + "/";
  }

  function cardsConfig() {
    var node = qs("[data-bb-cart-cards]");
    if (!node) return { products: [], moneyFormat: "${{amount}}" };
    try { return JSON.parse(node.textContent); } catch (e) { return { products: [], moneyFormat: "${{amount}}" }; }
  }

  function cardList() {
    return (cardsConfig().products || []).filter(function (p) {
      return p && p.available !== false && p.variantId;
    });
  }

  function cardByVariant(id) {
    if (!id) return null;
    var hit = null;
    cardList().forEach(function (p) { if (String(p.variantId) === String(id)) hit = p; });
    return hit;
  }

  function money(cents) {
    var fmt = cardsConfig().moneyFormat || "${{amount}}";
    var v = (Number(cents) || 0) / 100;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2))
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(v)));
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;")
      .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  /**
   * Liquid's `json` filter HTML-escapes quotes, ampersands and angle brackets
   * INSIDE string values, so the payload's _bundle_note arrives as
   * {&quot;card&quot;:&quot;Cheers&quot;,...} and JSON.parse throws on it.
   * It cannot be undone in Liquid: decoding &quot; there would put a raw quote
   * inside a JSON string literal and break the payload's own syntax. The
   * escaping is also what stops a customer message containing a closing script
   * tag from breaking out of the payload block, so it has to survive until here.
   * (Never write that tag literally in here, even inside a comment — the HTML
   * parser ends the script at the first one it sees and dumps the rest as text
   * onto the page. Which is exactly what happened when this comment first said
   * it the other way round.)
   *
   * A detached textarea is the reliable decoder and is safe: nothing is ever
   * inserted into the live document.
   */
  var decoder = null;
  function decodeEntities(str) {
    if (typeof str !== "string" || str.indexOf("&") === -1) return str;
    if (!decoder) decoder = document.createElement("textarea");
    decoder.innerHTML = str;
    return decoder.value;
  }

  function deepDecode(value) {
    if (typeof value === "string") return decodeEntities(value);
    if (Object.prototype.toString.call(value) === "[object Array]") return value.map(deepDecode);
    if (value && typeof value === "object") {
      var out = {};
      Object.keys(value).forEach(function (k) { out[decodeEntities(k)] = deepDecode(value[k]); });
      return out;
    }
    return value;
  }

  function postJson(path, body) {
    return fetch(cartRoot() + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(path + " failed");
      return res.json();
    });
  }

  function alpineCart() {
    try { return window.Alpine && window.Alpine.store && window.Alpine.store("cart"); } catch (e) { return null; }
  }

  /* assets/bb-cart.js owns the one scroll-lock implementation — it has to fix
     the same bug for its own two modals, and a second copy here would drift.
     It is loaded with defer by both sections that render this snippet, so it
     has always run by the time a click can open this dialog; the inline
     fallback only matters if that file failed to load entirely. */
  function lockScroll() {
    if (window.BBScrollLock) return window.BBScrollLock.lock();
    /* Class only. The html.bb-cart-modal-open rule already stops the scroll,
       and writing body.style.overflow here is what shifted the centred layout
       sideways before -- do not reintroduce it in the fallback either. */
    document.documentElement.classList.add("bb-cart-modal-open");
  }

  function unlockScroll() {
    if (window.BBScrollLock) return window.BBScrollLock.unlock();
    document.documentElement.classList.remove("bb-cart-modal-open");
  }

  function busy(on) {
    var s = alpineCart();
    if (s) s.loading = !!on;
  }

  function refresh() {
    var s = alpineCart();
    if (s && typeof s.reload === "function") s.reload();
    else window.location.reload();
  }

  function fields() {
    var m = modal();
    var get = function (sel) { var el = qs(sel, m); return el ? el.value.trim() : ""; };
    var on = function (sel) { var el = qs(sel, m); return !!(el && el.checked); };
    return {
      skip: on("[data-bb-pb-skip]"),
      blank: on("[data-bb-pb-blank]"),
      to: get("[data-bb-pb-to]"),
      from: get("[data-bb-pb-from]"),
      message: get("[data-bb-pb-message]")
    };
  }

  /* NOTHING IS HIDDEN AND NOTHING IS EXPLAINED. Two fades, because the blank
     toggle has to survive one of them: is-inert kills the whole form (there is
     nothing to leave blank if no card is coming), is-blanked fades only
     [data-bb-pb-fields], which the toggle sits outside of. */
  function syncVisibility() {
    var m = modal();
    var formRoot = qs("[data-bb-pb-form]", m);
    var fieldsBox = qs("[data-bb-pb-fields]", m);
    var blankEl = qs("[data-bb-pb-blank]", m);
    var f = fields();

    if (formRoot) {
      formRoot.hidden = false;
      formRoot.classList.toggle("is-inert", f.skip);
      formRoot.classList.toggle("is-blanked", !f.skip && f.blank);
    }
    if (blankEl) blankEl.disabled = f.skip;
    if (fieldsBox) {
      qsa("input, textarea", fieldsBox).forEach(function (el) {
        el.disabled = f.skip || f.blank;
      });
      /* Ticking blank, or picking the No card tile, ANSWERS the demand for a
         message -- so the prompt goes with it, or it sits there in red over a
         set of faded fields nobody is being asked to fill in. */
      if (f.skip || f.blank) fieldsBox.classList.remove("is-missing");
    }
  }

  /* THE SAVE-BLOCKED PROMPTS. Both used to be one word in the footer beside
     Cancel -- the one spot that cannot fix the problem -- so a refused Save
     read as a broken button, and the only other signal was a shake. There are
     two now, each beside the control that can answer it, and no shake at all.

     KEEP THESE IN STEP WITH assets/bb-cart.js. The builder controller has the
     same three functions over the same two CSS hooks; the only difference is
     the attribute prefix. */
  var PICK_MSG = "Select an option to continue";

  function clearPrompt() {
    var m = modal();
    var p = qs("[data-bb-pb-pick]", m);
    if (p) p.classList.remove("is-missing");
    var f = qs("[data-bb-pb-fields]", m);
    if (f) f.classList.remove("is-missing");
  }

  /* `message` is for a refusal that is NOT "you have not picked a design" --
     it is the only visible place in this dialog to say so, and the default is
     put back every time so one special case cannot leave its wording behind
     for the next ordinary one. */
  function demandPick(message) {
    var p = qs("[data-bb-pb-pick]", modal());
    if (!p) return;
    var line = qs("[data-bb-pb-pickmsg] span", p);
    if (line) line.textContent = message || PICK_MSG;
    p.classList.add("is-missing");
    try { p.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch (e) {}
  }

  /* FROM, not Message -- see the long note on demandFrom() in
     assets/bb-cart.js for why, and for why it is unconditional. */
  function demandFrom() {
    var m = modal();
    var f = qs("[data-bb-pb-fields]", m);
    if (f) f.classList.add("is-missing");
    var input = qs("[data-bb-pb-from]", m);
    if (!input) return;
    try { input.focus({ preventScroll: true }); } catch (e) { try { input.focus(); } catch (e2) {} }
    try { input.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch (e) {}
  }

  /* Arrows are not decoration: if every design already fits, they do nothing,
     so they go. Measured rather than assumed -- the dialog width and the card
     count both change. */
  function syncArrows() {
    var m = modal();
    var nav = qs("[data-bb-pb-nav]", m);
    var track = qs("[data-bb-pb-track]", m);
    if (nav && track) nav.hidden = track.scrollWidth <= track.clientWidth + 1;
  }

  /* THE "NO CARD" TILE -- keep in step with assets/bb-cart.js, which carries
     the same three pieces under the same names. Sending a gift with no card
     used to be a link in the footer, so two controls answered the same
     question: the grid asked "which card?", the link asked "any card?". That
     split made skip a MODE, the mode emptied the form pane, and the empty
     pane needed a sentence to fill it. It is a tile now. One control.

     NONE_ID is a sentinel, never a variant -- nothing is added to the cart
     for it. selectCard() turns it into `skip.checked = true`, and fields(),
     save(), buildProps() and syncCardLine() all read that checkbox exactly as
     before. None of them was touched. */
  var NONE_ID = "__bb_no_card__";

  var NO_CARD_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/>' +
    '<path d="M3 7l9 6.5L21 7"/><path d="M3.5 20.5 20.5 3.5"/></svg>';

  /* Prepended below. Change that unshift to a push and it sits at the END of
     the grid -- the one knob worth having once cards carry a price. */
  function noCardTile(on) {
    return '<article class="bb-cart-modal__card bb-cart-modal__card--none' +
      (on ? " is-selected" : "") + '"' +
      ' data-bb-pb-card data-variant-id="' + NONE_ID + '"' +
      ' role="button" tabindex="0"' +
      ' aria-label="Send this gift without a card' + (on ? ", selected" : "") + '">' +
      '<div class="bb-cart-modal__card-media">' + NO_CARD_SVG + "<em>No card</em>" +
      '<span class="bb-cart-modal__badge" aria-hidden="true">✓</span></div>' +
      "<h3>Send without a card</h3></article>";
  }

  function renderCards() {
    var m = modal();
    var track = qs("[data-bb-pb-track]", m);
    var empty = qs("[data-bb-pb-empty]", m);
    if (!track) return;
    var products = cardList();
    if (!products.length) {
      track.innerHTML = "";
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    /* Chip, not banner; and no price line at zero. Both match renderCards in
       assets/bb-cart.js -- the two dialogs share one stylesheet, so the markup
       they write has to agree. See the note there. */
    var tiles = products.map(function (p) {
      var on = state.selectedVariantId && String(p.variantId) === String(state.selectedVariantId);
      var img = p.image ? '<img src="' + p.image + '" alt="' + esc(p.title) + '">' : "";
      return '<article class="bb-cart-modal__card' + (on ? " is-selected" : "") + '"' +
        ' data-bb-pb-card data-variant-id="' + p.variantId + '"' +
        ' role="button" tabindex="0"' +
        ' aria-label="' + esc(p.title) + (on ? ", selected" : "") + '">' +
        '<div class="bb-cart-modal__card-media">' + img +
        '<span class="bb-cart-modal__badge" aria-hidden="true">✓</span></div>' +
        "<h3>" + esc(p.title) + "</h3>" +
        (p.price ? "<p>" + money(p.price) + "</p>" : "") + "</article>";
    });

    /* From the checkbox, not from state: this runs on re-render too, and the
       checkbox is what survives one. */
    var skipEl = qs("[data-bb-pb-skip]", m);
    tiles.unshift(noCardTile(!!(skipEl && skipEl.checked)));

    track.innerHTML = tiles.join("");
    syncArrows();
  }

  /* NOTHING AT ZERO. "Free" said nothing a customer did not already know --
     every card is free today -- and put a price-shaped thing in a dialog with
     no prices in it. The day cards carry a real figure this starts printing
     it, with no markup change. Keep in step with assets/bb-cart.js. */
  function cardPrice(card) {
    return (card && card.price) ? money(card.price) : "";
  }

  /* THE FOOTER NAMES A CARD OR SAYS NOTHING. "No card with this gift" restated
     a choice the customer had made one tile away, a second earlier. The tile
     is the statement. */
  function syncChosen() {
    var m = modal();
    if (!m) return;
    var skipEl = qs("[data-bb-pb-skip]", m);
    var skipping = !!(skipEl && skipEl.checked);
    var card = skipping ? null : cardByVariant(state.selectedVariantId);
    var sum = qs("[data-bb-pb-sum]", m);
    if (!sum) return;
    var price = cardPrice(card);
    sum.innerHTML = card
      ? "<strong>" + esc(card.title) + "</strong>" + (price ? " \u00b7 " + price : "")
      : "";
  }

  function selectCard(variantId) {
    var m = modal();
    var none = String(variantId) === NONE_ID;

    state.selectedVariantId = none ? null : variantId;
    var skip = qs("[data-bb-pb-skip]", m);
    if (skip) skip.checked = none;

    qsa("[data-bb-pb-card]", m).forEach(function (tile) {
      var on = String(tile.getAttribute("data-variant-id")) === String(variantId);
      tile.classList.toggle("is-selected", on);
      /* The chip is drawn from the is-selected class. */
    });
    clearPrompt();
    syncChosen();
    syncVisibility();
  }

  function openFor(btn) {
    var m = modal();
    if (!m) return;
    var host = btn.closest("[data-bb-prebuilt]");
    var node = host && qs("[data-bb-prebuilt-payload]", host);
    if (!node) return;
    var payload;
    try { payload = deepDecode(JSON.parse(node.textContent)); } catch (e) { return; }

    if (m.parentNode !== document.body) document.body.appendChild(m);

    var duplicate = btn.hasAttribute("data-bb-prebuilt-duplicate");
    state.mode = duplicate ? "duplicate" : "edit";
    state.payload = payload;
    /* cardTitle, NOT cardVariantId. The payload's cardVariantId falls back to
       the resolved card PRODUCT's first variant when there is no card line --
       it exists so a save knows what to add, not to say one is already there.
       Reading it as a selection pre-highlighted a design on a box that had no
       card, on the one screen whose job is to get a design chosen.
       snippets/bb-cart-prebuilt.liquid writes cardTitle from the box's own
       `card` property, which is blank exactly when no card is on it. */
    var hasCard = !!payload.cardTitle;
    state.selectedVariantId = hasCard ? (payload.cardVariantId || null) : null;

    var set = function (sel, val) { var el = qs(sel, m); if (el) el.value = val; };
    var check = function (sel, val) { var el = qs(sel, m); if (el) el.checked = !!val; };
    var text = function (sel, val) { var el = qs(sel, m); if (el) el.textContent = val; };

    /* ADDING AND EDITING ARE NOT THE SAME SCREEN. "Update the card included
       with this gift" on a box with no card describes something that is not
       there. */
    text("[data-bb-pb-title]", duplicate
      ? "Send this gift to someone else"
      : (hasCard
          ? (payload.to ? "Edit " + payload.to + "'s card" : "Edit card")
          : "Add a card"));
    text("[data-bb-pb-lede]", duplicate
      ? "We’ll add another to your cart. Change who it’s for, and the message if you need to."
      : (hasCard
          ? "Update the card included with this gift."
          : "Choose a design and write your message."));
    text("[data-bb-pb-save]", duplicate ? "Add this gift" : "Save Changes");
    /* "To (new recipient)" named a field rather than asked a question, and the
       label is doing nothing the placeholder cannot. */
    text("[data-bb-pb-to-label]", "To");

    /* THE MESSAGE CARRIES OVER ON A DUPLICATE; ONLY "To" CLEARS. A corporate
       order sends one message to twenty people and changes nothing but the
       name, so clearing it meant retyping it twenty times. A personal sender
       usually does rewrite it -- and it is sitting in front of them in an
       editable field, with To empty and focused. Blank carries for the same
       reason: a duplicate of a deliberately blank card should be blank too.
       Keep in step with openModal() in assets/bb-cart.js. */
    set("[data-bb-pb-to]", duplicate ? "" : (payload.to || ""));
    set("[data-bb-pb-from]", payload.from || "");
    set("[data-bb-pb-message]", payload.message || "");
    check("[data-bb-pb-blank]", payload.blank === true);
    /* FALSE, not `!payload.cardTitle`. A box with no card used to open with
       skip already ticked, which now means the "No card" tile would be
       pre-chosen on the one screen whose job is to get a card chosen. Opening
       with nothing selected hands the decision back: save() refuses until a
       tile is picked, and the footer says so. Costs one extra click when
       duplicating a box that never had a card -- the right trade, since that
       is an explicit choice on a new gift rather than one inherited. */
    check("[data-bb-pb-skip]", false);
    text("[data-bb-pb-count]", String(((qs("[data-bb-pb-message]", m) || {}).value || "").length));

    var toInput = qs("[data-bb-pb-to]", m);
    if (toInput) toInput.placeholder = duplicate ? "Who’s this one for?" : "Recipient’s name";

    renderCards();
    syncVisibility();
    clearPrompt();
    syncChosen();

    m.hidden = false;
    lockScroll();

    /* AFTER the dialog is on screen. renderCards() measures the track to
       decide whether the arrows have anything to scroll, and while the modal
       is still [hidden] everything measures 0 wide -- so the nav hid itself
       on every open and stayed hidden. */
    syncArrows();

    /* The one field a duplicate must change is the one the cursor lands in. */
    if (duplicate && toInput) {
      try { toInput.focus(); } catch (e) {}
    }
  }

  function close() {
    var m = modal();
    if (!m) return;
    m.hidden = true;
    unlockScroll();
    state.payload = null;
  }

  /* THERE IS NO shake() ANY MORE, and nothing should bring it back. It read as
     the site glitching rather than as a refusal -- which is what a 420ms
     judder always risks when the thing it is attached to has not said
     anything. Every blocked save now has a message beside the control that is
     missing something. assets/bb-cart.js lost the same function and
     assets/bb-cart.css lost the @keyframes. */

  function newGrp() {
    return "g" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  /**
   * The card line's properties -- the PDP-extra shape and nothing more.
   *
   * Every key here is one snippets/ub-extras-add.liquid already writes for an
   * extra (see extraItems there), so the packing slip and the 3PL need no
   * change. Do NOT add a key to mark this line as the card: the property
   * vocabulary goes to Extensiv and gaining a key needs warehouse sign-off.
   * bb-cart-prebuilt.liquid recognises it by the 'Card' product tag instead.
   */
  function cardLineProps(payload, f, grp) {
    var props = {
      "Bundle": payload.title || "",
      "_box_sku": payload.boxSku || "",
      "_ub_grp": grp
    };
    var to = (f.skip || f.blank) ? "" : f.to;
    if (to) props["Gift to"] = to;
    return props;
  }

  /**
   * Bring the card LINE into line with what was just saved on the box.
   *
   * qty tracks the box's quantity: two copies of a box need two cards. Picking
   * a different design is add-then-remove rather than a variant swap, because
   * cart/change.js cannot change a line's variant.
   *
   * Resolves to the last cart response, or null when there was nothing to do.
   */
  function syncCardLine(payload, f, card, grp, qty) {
    var key = payload.cardLineKey;

    if (f.skip || !card) {
      if (!key) return Promise.resolve(null);
      var drop = {};
      drop[key] = 0;
      return postJson("cart/update.js", { updates: drop, sections: SECTIONS });
    }

    var props = cardLineProps(payload, f, grp);

    if (key && String(payload.cardLineVariantId) === String(card.variantId)) {
      return postJson("cart/change.js", {
        id: key,
        quantity: qty,
        properties: props,
        sections: SECTIONS
      });
    }

    return postJson("cart/add.js", {
      items: [{ id: card.variantId, quantity: qty, properties: props }],
      sections: SECTIONS
    }).then(function (addRes) {
      if (!key) return addRes;
      var remove = {};
      remove[key] = 0;
      return postJson("cart/update.js", { updates: remove, sections: SECTIONS });
    });
  }

  /**
   * Start from the line's CURRENT properties and change only the card fields.
   * _bundle_note holds the SKUs the warehouse packs from, so it is parsed and
   * mutated in place — skus[0] (the box) is never touched.
   *
   * Returns null if the line has a _bundle_note that will not parse. That is a
   * refusal, not a fallback: writing the new card name while leaving the old
   * SKU in the pack list would show the customer one card and ship another,
   * and nothing would surface it until the recipient opened the box.
   */
  function buildProps(payload, f, card, grp) {
    var props = {};
    var existing = payload.props;
    if (!existing || typeof existing !== "object" ||
        Object.prototype.toString.call(existing) === "[object Array]") {
      /* Not the object shape we expect — refuse rather than write junk keys. */
      return null;
    }
    Object.keys(existing).forEach(function (k) { props[k] = existing[k]; });

    var title = f.skip ? "" : (card ? card.title : (payload.cardTitle || ""));
    var to = (f.skip || f.blank) ? "" : f.to;
    var from = (f.skip || f.blank) ? "" : f.from;
    var message = (f.skip || f.blank) ? "" : f.message;

    props.card = title;
    props.to = to;
    props.from = from;
    props.message = message;

    /* The card is a LINE now, so the pack list must NOT also carry it --
       skus[1] plus a card line is two cards in one box. See the note at the
       top of this file. */
    delete props._cardSku;

    var bn = null;
    if (typeof existing._bundle_note === "string" && existing._bundle_note) {
      try { bn = JSON.parse(existing._bundle_note); } catch (e) { bn = null; }
      if (!bn || typeof bn !== "object") return null;
    }
    if (bn && typeof bn === "object") {
      bn.card = title;
      bn.to = to;
      bn.from = from;
      bn.message = message;
      delete bn._cardSku;
      if (Object.prototype.toString.call(bn.skus) === "[object Array]" && bn.skus.length) {
        /* REMOVED, NOT BLANKED. This used to assign {} to index 1, which is
           not the same thing: the Make scenario that feeds the warehouse
           iterates _bundle_note.skus and aggregates every entry as "SKU|QTY"
           into the BundleSKUs line of the Infoplus assembly instructions, so
           an empty object prints a junk row rather than nothing. splice also
           handles a box that never had a second entry -- assigning index 1
           would have created one.

           splice(1, 1) and not splice(1): only the card slot goes. buildBoxProps
           in snippets/ub-extras-add.liquid never writes more than [box, card],
           so today they are the same -- but dropping the tail outright would
           quietly delete anything a later change added after the card. */
        bn.skus.splice(1, 1);
        if (state.mode === "duplicate" && bn.skus[0] && typeof bn.skus[0] === "object") {
          bn.skus[0].quantity = 1;
        }
      }
      props._bundle_note = JSON.stringify(bn);
    }

    /* The grouping key is what ties the card line (and every other extra) to
       this box, so the box line has to carry it. On a duplicate that is a
       freshly minted one -- not the original's, and not none at all, which
       left the copy unaddressable and gave a cart-side add-on nothing to
       attach to. On an edit it is the box's existing key, or a new one for an
       older box line that never got issued one. */
    props._ub_grp = grp;

    return props;
  }

  function save() {
    var payload = state.payload;
    if (!payload) return close();
    var f = fields();

    if (!f.skip) {
      if (!state.selectedVariantId) { demandPick(); return; }
      if (!f.blank && !f.from) { demandFrom(); return; }
    }

    var duplicate = state.mode === "duplicate";
    var card = cardByVariant(state.selectedVariantId);
    var grp = duplicate ? newGrp() : (payload.ubGrp || newGrp());

    var props = buildProps(payload, f, card, grp);
    if (!props) {
      console.error("[BB prebuilt note] refusing to save: the line's _bundle_note " +
        "could not be read, so the pack list cannot be kept in step with the card.");
      /* NOT a missing step -- a broken line. It used to shake Save and say
         nothing, so the dialog looked frozen. The picker's prompt is the only
         visible place in here to put a sentence, so it carries this one. */
      demandPick("Something went wrong with this gift. Refresh the page and try again.");
      return;
    }

    close();
    busy(true);

    /* A duplicate is ONE add.js carrying both items, so a new box can never
       land without its card or a card without its box. */
    if (duplicate) {
      var items = [{ id: payload.variantId, quantity: 1, properties: props }];
      if (!f.skip && card) {
        items.push({
          id: card.variantId,
          quantity: 1,
          properties: cardLineProps(payload, f, grp)
        });
      }
      return postJson("cart/add.js", { items: items, sections: SECTIONS })
        .then(refresh)
        .catch(function (err) {
          console.error("[BB prebuilt note]", err);
          busy(false);
        });
    }

    /* An edit CANNOT be one request: the box line is a change.js and the card
       line may be an add.js, and there is no endpoint that does both.
       So the order is chosen for how it fails. Box line FIRST: if the card
       call then dies, the cart is left in the old pre-pricing state -- card
       named on the box, nothing charged for it -- which is the behaviour this
       whole change replaces, and is survivable. The other order charges for a
       card whose message never saved, and the customer finds out when the
       recipient opens the box. Never flip these two. */
    return postJson("cart/change.js", {
      id: payload.key,
      quantity: payload.quantity,
      properties: props,
      sections: SECTIONS
    }).then(function (boxRes) {
      return syncCardLine(payload, f, card, grp, payload.quantity)
        .then(function (cardRes) { return cardRes || boxRes; })
        .catch(function (err) {
          /* Surface it, but still repaint: the note itself DID save. */
          console.error("[BB prebuilt note] the card line could not be synced; " +
            "the gift note saved but the card may not be charged.", err);
          return boxRes;
        });
    }).then(refresh).catch(function (err) {
      console.error("[BB prebuilt note]", err);
      busy(false);
    });
  }

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-bb-prebuilt-edit-note], [data-bb-prebuilt-duplicate]");
    if (open) { event.preventDefault(); openFor(open); return; }

    if (!event.target.closest("[data-bb-prebuilt-modal]")) return;

    if (event.target.closest("[data-bb-pb-close]")) { event.preventDefault(); close(); return; }
    if (event.target.closest("[data-bb-pb-save]")) { event.preventDefault(); save(); return; }

    /* THE SECOND RED RING. These tiles are tabindex elements rather than real
       buttons, and Chrome hands those :focus-visible on a plain mouse click --
       so a clicked card got the selected border AND the focus outline. Blurring
       here leaves the keyboard path alone: Enter and Space keep the ring, which
       is the only place it is needed. */
    var tile = event.target.closest("[data-bb-pb-card]");
    if (tile) {
      event.preventDefault();
      selectCard(tile.getAttribute("data-variant-id"));
      if (tile.blur) tile.blur();
      return;
    }

    var track = qs("[data-bb-pb-track]", modal());
    if (event.target.closest("[data-bb-pb-prev]") && track) {
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: "smooth" });
    }
    if (event.target.closest("[data-bb-pb-next]") && track) {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: "smooth" });
    }
  });

  document.addEventListener("change", function (event) {
    if (!event.target.closest("[data-bb-prebuilt-modal]")) return;
    if (event.target.matches("[data-bb-pb-skip]") && event.target.checked) {
      state.selectedVariantId = null;
      renderCards();
    }
    if (event.target.matches("[data-bb-pb-skip]")) syncChosen();
    if (event.target.matches("[data-bb-pb-skip], [data-bb-pb-blank]")) syncVisibility();
  });

  /* DRAG TO SCROLL. Touch already does this; this is for a mouse, which
     otherwise has only shift+wheel and the arrows. The 4px threshold keeps a
     drag from also counting as a click on whichever card it started on. */
  (function () {
    var down = false, moved = false, startX = 0, startLeft = 0, el = null;

    document.addEventListener("pointerdown", function (e) {
      if (e.button !== 0) return;
      var t = e.target.closest("[data-bb-pb-track]");
      if (!t) return;
      el = t; down = true; moved = false;
      startX = e.clientX; startLeft = t.scrollLeft;
    });

    window.addEventListener("pointermove", function (e) {
      if (!down || !el) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) { moved = true; el.classList.add("is-dragging"); }
      e.preventDefault();
      el.scrollLeft = startLeft - dx;
    }, { passive: false });

    window.addEventListener("pointerup", function () {
      if (!down) return;
      down = false;
      var t = el; el = null;
      if (moved && t) window.setTimeout(function () { t.classList.remove("is-dragging"); }, 0);
    });

    window.addEventListener("resize", syncArrows);
  })();

  document.addEventListener("input", function (event) {
    if (event.target.matches("[data-bb-pb-message]")) {
      var count = qs("[data-bb-pb-count]", modal());
      if (count) count.textContent = String(event.target.value.length);
      return;
    }

    /* The prompt clears on the first keystroke in the field it is about, and
       only that one: typing a name says nothing about whether a design has
       been chosen, so clearPrompt() would clear too much. */
    if (event.target.matches("[data-bb-pb-from]")) {
      var f = qs("[data-bb-pb-fields]", modal());
      if (f) f.classList.remove("is-missing");
    }
  });

  document.addEventListener("keydown", function (event) {
    var m = modal();
    if (event.key === "Escape" && m && !m.hidden) close();

    /* The tiles carry role="button" and tabindex="0", so they answer Enter and
       Space like a button. This is the only keyboard route to "no card" now
       that the footer checkbox is display:none. */
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return;
    if (!event.target.closest("[data-bb-prebuilt-modal]")) return;
    var tile = event.target.closest("[data-bb-pb-card]");
    if (!tile) return;
    event.preventDefault();
    selectCard(tile.getAttribute("data-variant-id"));
  });
})();
